import { getVccTooltipText } from 'app/components/pages/Extranet/ExtranetBookings/common/utils/vccTooltip';
import { DEFAULT_ADULTS_PAX } from 'app/typings/PAX';
import type { BookingDetails } from 'app/typings/extranetBookings/booking';
import { differenceInCalendarDays } from 'app/utils/dayjs';

export const getTooltipText = getVccTooltipText;

export const getNbNight = (booking: BookingDetails) => {
  return differenceInCalendarDays(
    new Date(booking.checkout),
    new Date(booking.checkin)
  );
};

export const getTotalPrice = (booking: BookingDetails) => {
  const nbNight = getNbNight(booking);

  const bedRoomPriceForAllNights =
    (booking.room.bedPricePerNight ?? 0) * nbNight;

  const singleOrExtraGuest =
    booking.pax.adults === DEFAULT_ADULTS_PAX
      ? 0
      : booking.pax.adults > DEFAULT_ADULTS_PAX
        ? (booking.room.additionalAdultPricePerNight ?? 0)
        : (booking.room.singleCustomerDiscountPerNight ?? 0);

  const paxForAllNights =
    singleOrExtraGuest * nbNight * (booking.pax.adults - DEFAULT_ADULTS_PAX);

  const childrenPaxForAllNights =
    (booking.room.additionalChildPricePerNight ?? 0) *
    booking.pax.children *
    nbNight;

  return (
    booking.room.discountPrice -
    bedRoomPriceForAllNights -
    paxForAllNights -
    childrenPaxForAllNights
  );
};
